<template>
    <div class="suggest-wrap">
        <!--
            Important! keyup.esc.stop and keydown.enter.prevent necessary to prevent these keys from propagating to form
        -->
        <input
            v-model="q"
            :required="required"
            :name="name + 'Display'"
            v-on:input="updateValue"
            autocomplete="off"
            class="text-input"
            type="search"
            @keyup.esc.stop="validate"
            @keydown.down="moveDown"
            @keydown.up="moveUp"
            @keydown.enter.prevent="settle"
            @wheel.prevent.stop="mouseWheel($event)"
            v-bind="$attrs"
            @keydown.enter="openPatientSearch(q)"
        />
        <input type="hidden" :name="name" :value="value_" />

        <ul
            :id="`${$attrs.id}-suggest-list`"
            class="suggest-list"
            v-show="open"
            @wheel.prevent.stop="mouseWheel($event)"
        >
            <span class="title">Sökträffar</span>
            <li
                v-for="(item, index) in this.results"
                :key="index"
                @mouseleave="highlightedPosition = NaN"
                @mouseenter="highlightedPosition = index"
                @mousedown="select"
                :name="name + '-suggest'"
                :class="['suggest-item', { highlighted: index === highlightedPosition }]"
            >
                <div class="code">{{ item.code }}</div>
                <span class="display-name">{{ item.displayName }}</span>
            </li>
            <Button
                class="search-results-button"
                type="button"
                role="button"
                @mousedown="openPatientSearch(q)"
                :disabled="!q || q.length === 0"
                size="secondary"
            >
                Visa alla sökträffar
            </Button>
            <button class="advanced-search hollow-button" type="button" role="button" @mousedown="openPatientSearch()">
                <img class="gray" src="@/assets/patient_filled.svg" />Avancerad patientsök
            </button>
        </ul>
        <svg xmlns:svg="<http://www.w3.org/2000/svg>" version="1.1" height="0" width="0" style="display: none">
            <defs>
                <filter id="gray">
                    <feColorMatrix
                        color-interpolation-filters="sRGB"
                        type="matrix"
                        values="0.52 0   0   0   0
                            0   0.61  0   0   0
                            0   0   0.64  0   0
                            0   0   0   1   0 "
                    />
                </filter>
            </defs>
        </svg>
    </div>
</template>

<script>
    import AutoCompleteWidget from "@/components/widgets/AutoCompleteWidget.vue";
    import PatientSearch from "@/tabs/Patient/PatientSearch.vue";
    import Button from "@/components/Button.vue";
    import linkEvents from "@/linkEvents";

    export default {
        extends: AutoCompleteWidget,
        name: "CustomSuggestWidget",
        components: {
            Button,
        },
        props: {
            open: {
                type: Boolean,
                default: false,
            },
        },
        emits: ["searchDone"],
        methods: {
            openPatientSearch(q) {
                this.$emit("searchDone");

                if (this.results.length === 1) {
                    linkEvents.$emit("patientid_changed", JSON.stringify(this.results[0] ?? {}));

                    return;
                }

                this.$store.dispatch("tabs/openTab", {
                    component: PatientSearch,
                    parameters: { q },
                });
            },
        },
    };
</script>
<style lang="sass" scoped>
    @import @/style/variables

    /* Bootstrap - Start */
    @import "bootstrap/scss/functions"
    @import "bootstrap/scss/variables"
    @import "bootstrap/scss/mixins"
    @import "bootstrap/scss/root"
    @import "bootstrap/scss/reboot"

    @import "bootstrap/scss/type"
    @import "bootstrap/scss/buttons"
    @import "bootstrap/scss/forms"
    /* Bootstrap - End */

    @import @/style/deprecated_main

    .suggest-wrap
        position: relative

    .suggest-list
        -webkit-box-sizing: border-box
        -moz-box-sizing: border-box
        box-sizing: border-box
        position: absolute
        left: 0
        top: 48px
        width: 434px
        z-index: 100
        background: #ffffff
        padding: 30px !important
        box-shadow: 2px 2px 9px rgba(211, 216, 218, 0.52)
        border-radius: 4px
        display: grid
        grid-template-columns: auto 1fr
        grid-auto-flow: row

        > *
            width: 100%

        > .title
            color: #728296
            font-size: 14px
            line-height: 21px
            margin-bottom: 10px
            display: inline-block
            grid-column: 1 / 3
            margin-left: auto
            margin-right: auto

        .suggest-item
            display: grid
            grid-template-columns: subgrid
            grid-column: 1 / 3
            grid-auto-flow: column
            justify-items: flex-start
            width: 100%
            list-style: none
            margin: 0
            border-bottom: 1px solid #D3D8DA
            padding: 12px 0px 12px 20px
            text-align: start
            grid-gap: 1rem

            &:first-of-type
                border-top: 1px solid #D3D8DA

            > .code
                max-width: 14ch
                grid-column: 1
                word-break: break-word

            > .display-name
                grid-column: 2
                word-break: break-word

        .search-results-button, .advanced-search
            grid-column: 1 / 3

        .advanced-search
            justify-self: flex-end
            width: fit-content

    .hollow-button
        height: 28px
        margin-top: 28px
        color: #6C8188
        font-size: 16px
        font-weight: 500
        line-height: 28px
        border: none
        background-color: #FFFFFF
        float: right

        .gray
            height: 22px
            width: 25px
            filter: url('#gray')

    .highlighted
        background: #eee
        cursor: pointer
</style>
